import { z } from 'zod'
import { TrueFalse } from '~/enums/true-false'

/**
 * 產品子類目 - 多筆資料 Schema
 */
export const productSubListDataSchema = z.object({
  /** 是否上架 */
  isEnable: z.nativeEnum(TrueFalse),
  /** 子類目名稱(英) */
  nameEn: z.string(),
  /** 子類目名稱(中) */
  nameZh: z.string(),
  /** 主類目 ID */
  pmID: z.number(),
  /** 主類目名稱(中) */
  pmName: z.string(),
  /** 子類目 ID */
  psID: z.number(),
  /** 角色類型 */
  roleClass: z.string(),
  /** 排序 */
  sort: z.union([z.number(), z.literal('')])
})

/**
 * 產品子類目 - 多筆資料
 */
export interface ProductSubListData
  extends z.infer<typeof productSubListDataSchema> {}
